import axios from "../axiosConfig";
import { API_PREFIX_URL } from "constant";

export const getMetaAPI = async () => {
  const res = await axios.get(`${API_PREFIX_URL}/meta/`);
  return res;
};
